import { coreValues } from "@/mocks/aboutData";
import { useScrollReveal, useStaggerReveal } from "@/hooks/useScrollReveal";
import Icon from "@/components/feature/Icon";

export default function ValuesSection() {
  const { ref: headerRef, style: headerStyle } = useScrollReveal();
  const { containerRef, getItemStyle } = useStaggerReveal(coreValues.length, 100);

  return (
    <section className="py-24 md:py-32 bg-silver-50">
      <div className="px-6 md:px-10 lg:px-16">
        {/* Header */}
        <div ref={headerRef} style={headerStyle} className="max-w-3xl mb-16 md:mb-20">
          <p className="text-sm font-medium tracking-[0.2em] text-navy-700 uppercase mb-4">
            Core Values
          </p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-semibold text-navy-950 leading-tight">
            核心價值觀
          </h2>
        </div>

        {/* Values grid */}
        <div ref={containerRef} className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {coreValues.map((value, index) => (
            <div
              key={value.id}
              style={getItemStyle(index)}
              className="group bg-white rounded-3xl p-8 border border-silver-200 hover:border-navy-200 hover:shadow-xl hover:-translate-y-1 transition-all duration-500"
            >
              <div className="flex items-start justify-between mb-6">
                <div className="w-14 h-14 rounded-2xl bg-navy-950/5 flex items-center justify-center group-hover:bg-navy-950 transition-colors duration-300">
                  <Icon className={`${value.icon} text-2xl text-navy-950 group-hover:text-white transition-colors duration-300`} />
                </div>
                <span className="text-4xl font-bold text-silver-100 font-serif">
                  0{index + 1}
                </span>
              </div>
              <h3 className="text-lg md:text-xl font-semibold text-navy-950 mb-3">
                {value.title}
              </h3>
              <p className="text-silver-500 text-sm leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}